export function debug_dataexplorer_dates(config) {
	let {
		selectedTimezone,
		selectedTimezoneLabel,
		formatDateForTimezone,
		hasCalledDataExplorerSwanbot,
		dataExplorerLoadedSessionKey,
		dataExplorerSavedRangeKey,
		dataExplorerMaxAvailableKey,
		savedPeriodModePreference,
		modalOpenCountThisRefresh,
		isDailyOnlyLocked,
		shouldStartInDailyMode,
		maxDateStr,
		hasLoadedDataExplorerInSession
	} = config;

	let rangeDecisionDebug = {
		modalContext: '',
		modalContextReason: '',
		modalContextValuesHtml: '',
		periodMode: '',
		periodReason: '',
		source: '',
		sourceReason: '',
		selectedRange: '',
		extraDecisions: []
	};

	let escapeDebugHtml = function (value) {
		if (value === null || typeof value === 'undefined') {
			return 'n/a';
		}

		return String(value)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	};

	let stringifyDebugValue = function (value) {
		try {
			return JSON.stringify(value, null, 2);
		} catch (e) {
			return String(value);
		}
	};

	let formatDebugDateTime = function (dateObj) {
		if (!dateObj || Number.isNaN(dateObj.getTime())) {
			return 'n/a';
		}

		return formatDateForTimezone(dateObj, selectedTimezone, true) + ' ' + (selectedTimezoneLabel || selectedTimezone || 'UTC');
	};

	let setRangeDecisionDebug = function (updates) {
		rangeDecisionDebug = { ...rangeDecisionDebug, ...(updates || {}) };
	};

	let pushRangeDecisionDebug = function (message) {
		if (!message) {
			return;
		}
		rangeDecisionDebug.extraDecisions.push(message);
	};

	let renderRangeDecisionDebug = function () {
		let debugEl = document.getElementById('idp-range-debug');
		if (!debugEl) {
			return;
		}

		let extraItems = rangeDecisionDebug.extraDecisions.length
			? '<ul style="margin: 6px 0 0 18px; padding: 0;">' + rangeDecisionDebug.extraDecisions.map(item => '<li>' + item + '</li>').join('') + '</ul>'
			: '<div style="margin-top: 6px;">None</div>';

		debugEl.innerHTML = '' +
			'<div style="font-weight: 700; margin-bottom: 6px;">Date Picker Debug</div>' +
			'<div><strong>0. Modal context:</strong> ' + (rangeDecisionDebug.modalContext || 'n/a') + '</div>' +
			'<div style="margin-top: 2px;"><strong>Details:</strong> ' + (rangeDecisionDebug.modalContextReason || 'n/a') + '</div>' +
			(rangeDecisionDebug.modalContextValuesHtml || '') +
			'<div style="margin-top: 8px;"><strong>1. Default period mode:</strong> ' + (rangeDecisionDebug.periodMode || 'n/a') + '</div>' +
			'<div style="margin-top: 2px;"><strong>Why:</strong> ' + (rangeDecisionDebug.periodReason || 'n/a') + '</div>' +
			'<div style="margin-top: 8px;"><strong>2. Initial range source:</strong> ' + (rangeDecisionDebug.source || 'n/a') + '</div>' +
			'<div style="margin-top: 2px;"><strong>How it was calculated:</strong> ' + (rangeDecisionDebug.sourceReason || 'n/a') + '</div>' +
			'<div style="margin-top: 2px;"><strong>Applied range:</strong> ' + (rangeDecisionDebug.selectedRange || 'n/a') + '</div>' +
			'<div style="margin-top: 8px;"><strong>3. Extra decisions:</strong></div>' +
			extraItems;
	};

	let getModalContextDebug = function () {
		let graphDataState = window.WingmanState && window.WingmanState.swanbot_dataexplorer_graphdata
			? window.WingmanState.swanbot_dataexplorer_graphdata
			: null;
		let graphDataGraphsCount = graphDataState && Array.isArray(graphDataState.graphs) ? graphDataState.graphs.length : 0;
		let graphDataFiltersCount = graphDataState && Array.isArray(graphDataState.filters) ? graphDataState.filters.length : 0;
		let graphDataSubgraphCount = graphDataState && Array.isArray(graphDataState.subgraphGroupData) ? graphDataState.subgraphGroupData.length : 0;
		let graphDataSubgraphTitlesCount = graphDataState && Array.isArray(graphDataState.subgraphGroupTitles) ? graphDataState.subgraphGroupTitles.length : 0;
		let graphDataMainTitlesCount = graphDataState && Array.isArray(graphDataState.maingraphTitles) ? graphDataState.maingraphTitles.length : 0;
		let graphDataFocusKeysCount = graphDataState && graphDataState.focus && typeof graphDataState.focus === 'object' ? Object.keys(graphDataState.focus).length : 0;
		let graphDataAxisTypeKeysCount = graphDataState && graphDataState.axis_types && typeof graphDataState.axis_types === 'object' ? Object.keys(graphDataState.axis_types).length : 0;
		let graphDataCompareGraphsPresent = !!(graphDataState && ((Array.isArray(graphDataState.graphs_compare) && graphDataState.graphs_compare.length) || (!Array.isArray(graphDataState.graphs_compare) && graphDataState.graphs_compare)));
		let graphDataCompareSubgraphsPresent = !!(graphDataState && ((Array.isArray(graphDataState.subgraphs_compare) && graphDataState.subgraphs_compare.length) || (!Array.isArray(graphDataState.subgraphs_compare) && graphDataState.subgraphs_compare)));
		let graphDataOutputPresent = !!(graphDataState && graphDataState.output && String(graphDataState.output).trim() !== '');
		let hasGraphDataResponse = graphDataGraphsCount > 0 || graphDataFiltersCount > 0 || graphDataSubgraphCount > 0 || graphDataSubgraphTitlesCount > 0 || graphDataMainTitlesCount > 0 || graphDataFocusKeysCount > 0 || graphDataAxisTypeKeysCount > 0 || graphDataCompareGraphsPresent || graphDataCompareSubgraphsPresent || graphDataOutputPresent;
		let hasSavedRangeCache = false;
		let hasLoadedFlag = false;
		let loadedFlagRaw = null;
		let hasSavedMaxAvailable = false;
		let savedMaxAvailableRaw = '';
		let savedRangeCacheRaw = '';
		let hiddenInputsHaveValues = false;
		let hiddenStartRaw = '';
		let hiddenEndRaw = '';
		let savedContextParts = [];

		try {
			savedRangeCacheRaw = window.localStorage.getItem(dataExplorerSavedRangeKey) || '';
			hasSavedRangeCache = !!savedRangeCacheRaw;
		} catch (e) {
			console.log('Could not inspect DataExplorer saved range cache:', e);
		}

		try {
			loadedFlagRaw = window.sessionStorage.getItem(dataExplorerLoadedSessionKey);
			hasLoadedFlag = loadedFlagRaw === 'true';
			savedMaxAvailableRaw = window.sessionStorage.getItem(dataExplorerMaxAvailableKey) || '';
			hasSavedMaxAvailable = !!savedMaxAvailableRaw;
		} catch (e) {
			console.log('Could not inspect DataExplorer session context:', e);
		}

		let selectedStartInput = document.getElementById('date_start');
		let selectedEndInput = document.getElementById('date_end');
		hiddenStartRaw = selectedStartInput && selectedStartInput.value ? String(selectedStartInput.value).trim() : '';
		hiddenEndRaw = selectedEndInput && selectedEndInput.value ? String(selectedEndInput.value).trim() : '';
		hiddenInputsHaveValues = !!(hiddenStartRaw !== '' && hiddenEndRaw !== '');

		if (hasSavedRangeCache) savedContextParts.push('local saved range cache');
		if (hasLoadedFlag) savedContextParts.push('session loaded flag');
		if (hiddenInputsHaveValues) savedContextParts.push('hidden date_start/date_end values');
		if (savedPeriodModePreference) savedContextParts.push('saved period preference (' + savedPeriodModePreference + ')');
		if (hasSavedMaxAvailable) savedContextParts.push('latest-available cache');
		if (hasGraphDataResponse) savedContextParts.push('graphData response');

		let graphDataSummaryParts = [
			'initialized=' + (!!graphDataState),
			'hasResponsePayload=' + hasGraphDataResponse,
			'graphs=' + graphDataGraphsCount,
			'filters=' + graphDataFiltersCount,
			'subgraphGroupData=' + graphDataSubgraphCount,
			'subgraphGroupTitles=' + graphDataSubgraphTitlesCount,
			'maingraphTitles=' + graphDataMainTitlesCount,
			'focusKeys=' + graphDataFocusKeysCount,
			'axisTypeKeys=' + graphDataAxisTypeKeysCount,
			'graphs_compare=' + graphDataCompareGraphsPresent,
			'subgraphs_compare=' + graphDataCompareSubgraphsPresent,
			'output=' + graphDataOutputPresent
		];

		let contextValuesHtml = '' +
			'<details style="margin-top: 8px;">' +
				'<summary style="cursor: pointer;"><strong>Click to inspect context values</strong></summary>' +
				'<div style="margin-top: 6px;"><strong>Automatic request made this refresh:</strong> ' + escapeDebugHtml(hasCalledDataExplorerSwanbot ? 'true' : 'false') + '</div>' +
				'<div style="margin-top: 4px;"><strong>Session loaded flag (' + escapeDebugHtml(dataExplorerLoadedSessionKey) + '):</strong> ' + escapeDebugHtml(loadedFlagRaw === null ? 'null' : loadedFlagRaw) + '</div>' +
				'<div style="margin-top: 4px;"><strong>Local saved range cache (' + escapeDebugHtml(dataExplorerSavedRangeKey) + '):</strong> ' + escapeDebugHtml(savedRangeCacheRaw || 'empty') + '</div>' +
				'<div style="margin-top: 4px;"><strong>Hidden date_start:</strong> ' + escapeDebugHtml(hiddenStartRaw || 'empty') + '</div>' +
				'<div style="margin-top: 4px;"><strong>Hidden date_end:</strong> ' + escapeDebugHtml(hiddenEndRaw || 'empty') + '</div>' +
				'<div style="margin-top: 4px;"><strong>Latest-available cache (' + escapeDebugHtml(dataExplorerMaxAvailableKey) + '):</strong> ' + escapeDebugHtml(savedMaxAvailableRaw || 'empty') + '</div>' +
				'<div style="margin-top: 4px;"><strong>graphData summary:</strong> ' + escapeDebugHtml(graphDataSummaryParts.join(', ')) + '</div>' +
				'<details style="margin-top: 6px;">' +
					'<summary style="cursor: pointer;">graphData raw JSON</summary>' +
					'<pre style="margin: 6px 0 0; max-height: 180px; overflow: auto; white-space: pre-wrap; font-size: 11px; line-height: 1.35;">' + escapeDebugHtml(stringifyDebugValue(graphDataState || {})) + '</pre>' +
				'</details>' +
			'</details>';

		if (modalOpenCountThisRefresh === 0 && !hasCalledDataExplorerSwanbot && !hasGraphDataResponse && !hasSavedRangeCache && !hasLoadedFlag && !savedPeriodModePreference && !hasSavedMaxAvailable) {
			return {
				label: 'A. First time showing this modal to this user',
				reason: 'No saved range cache, session restore flag, saved period preference, latest-available cache, or swanbot data was found yet.',
				valuesHtml: contextValuesHtml
			};
		}

		if (modalOpenCountThisRefresh === 0 && !hasCalledDataExplorerSwanbot && !hasGraphDataResponse) {
			return {
				label: 'B. First time showing this modal this refresh',
				reason: 'No swanbot data has been loaded yet in this refresh. Available saved/browser context: ' + (savedContextParts.length ? savedContextParts.join(', ') : 'none detected') + '.',
				valuesHtml: contextValuesHtml
			};
		}

		let subsequentReasons = [];
		if (modalOpenCountThisRefresh > 0) {
			subsequentReasons.push('the modal has already been opened ' + modalOpenCountThisRefresh + ' time' + (modalOpenCountThisRefresh === 1 ? '' : 's') + ' during this refresh');
		}
		if (hasCalledDataExplorerSwanbot) {
			subsequentReasons.push('a swanbot request has already been made');
		}
		if (hasGraphDataResponse) {
			subsequentReasons.push('graphData is already present');
		}

		return {
			label: 'C. Subsequent time showing this modal to this user',
			reason: (subsequentReasons.length ? subsequentReasons.join('; ') : 'This modal is no longer in a first-open state') + '. Saved/browser context: ' + (savedContextParts.length ? savedContextParts.join(', ') : 'none detected') + '.',
			valuesHtml: contextValuesHtml
		};
	};

	let modalContextDebug = getModalContextDebug();

	setRangeDecisionDebug({
		modalContext: modalContextDebug.label,
		modalContextReason: modalContextDebug.reason,
		modalContextValuesHtml: modalContextDebug.valuesHtml || '',
		periodMode: shouldStartInDailyMode ? 'daily' : 'hourly',
		periodReason: isDailyOnlyLocked
			? 'Daily mode was forced because the current filter period or daily-only lock indicated day mode.'
			: (savedPeriodModePreference === 'day'
				? 'Daily mode was restored from the last applied modal period preference.'
				: 'Hourly mode was used because no daily-only lock or saved daily preference was active.')
	});
	pushRangeDecisionDebug('Latest available timestamp at modal load: ' + (maxDateStr || 'n/a') + ' UTC-backed source.');
	pushRangeDecisionDebug('Session restore allowed: ' + (hasLoadedDataExplorerInSession() ? 'yes' : 'no') + '.');
	pushRangeDecisionDebug('Saved modal period preference: ' + (savedPeriodModePreference || 'none') + '.');
	window.swanbot_dataexplorer_modal_open_count_this_refresh = modalOpenCountThisRefresh + 1;

	return {
		formatDebugDateTime,
		setRangeDecisionDebug,
		pushRangeDecisionDebug,
		renderRangeDecisionDebug
	};
}